import { useCallback } from "react";

interface UseMessageHandlersReturn {
  handleTypingProgress: () => void;
}

export const useMessageHandlers = (): UseMessageHandlersReturn => {
  const handleTypingProgress = useCallback((): void => {}, []);

  return {
    handleTypingProgress,
  };
};
